import React from "react";
import { useAccount } from 'wagmi';
import { useWeb3Modal } from '@web3modal/react';
import { trimAddress } from "../helper/functions";
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';

export const ConnectButton = function () {
    const { address, isConnected } = useAccount()
    const { open } = useWeb3Modal()

    return (
        <React.Fragment>

            <>
                {address && isConnected ? (

                    <button className='btn btn-primary' onClick={() => open()}>
                        {trimAddress(address)}
                    </button>

                ) : (
                    <button className='btn btn-primary' onClick={() => open()}>
                        <AccountBalanceWalletIcon className='me-2' />
                        Connect
                    </button>
                )
                }

            </>

        </React.Fragment >
    );
};

export default ConnectButton;